// The 100xWorks product app lives under this sub-path.
// The Jarvis Company umbrella site lives at the root ("/").
export const X_BASE = "/100xWorks";

// Prefixes an internal route with the 100xWorks base path.
// Leaves anchors ("#..."), external links ("http...") and already-prefixed paths untouched.
export const xPath = (path) => {
  if (!path || typeof path !== "string") return path;
  if (!path.startsWith("/")) return path; // anchors, external, relative
  if (path === X_BASE || path.startsWith(`${X_BASE}/`)) return path; // already prefixed
  if (path === "/") return X_BASE;
  return `${X_BASE}${path}`;
};

// English pages live under /en: /en, /en/100xWorks, /en/100xWorks/blog/<slug>…
// The router runs with langBase() as its basename there, so <Link> and
// navigate() keep the prefix by themselves; plain <a href> links go through
// langHref(). French pages keep their addresses without prefix.
export const langBase = () =>
  typeof window !== "undefined" && /^\/en(\/|$)/.test(window.location.pathname) ? "/en" : "";

// Address of an internal path in the given language ("fr" or "en").
export const pathIn = (lang, path) => {
  if (lang !== "en") return path;
  return path === "/" ? "/en" : `/en${path}`;
};

// Prefixes an internal absolute path for a plain <a href> on an English page.
export const langHref = (path) => {
  if (!langBase() || typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return path;
  return pathIn("en", path);
};
